import React from 'react'
import { Form, Formik } from 'formik'
import Button from './common/Button'
import Input from './common/Input'
import Select from './common/Select'
import ServerError from './common/ServerError'
import { usePostRequest } from '../hooks/request'
import { BILLING_PAYMENT_LIST } from '../urls'
import { required } from '../utils/validators'

const METHODS = [
    { id: 'cash', name: 'Наличные' },
    { id: 'bank', name: 'Банковский перевод' },
    { id: 'card', name: 'Карта' },
    { id: 'click', name: 'Click/Payme' },
]

/** To'lov qo'shish formasi. Qoldiq oldindan taklif qilinadi. */
export default function ContractPaymentCreate({ invoice, onSuccess, onCancel }) {
    const create = usePostRequest({ url: BILLING_PAYMENT_LIST })

    async function onSubmit(data, actions) {
        const { success } = await create.request({
            data: {
                invoice: invoice.id,
                amount: parseInt(data.amount, 10),
                paid_at: data.paidAt,
                method: data.method,
                comment: data.comment || null,
            },
        })

        if (success) {
            actions.resetForm()
            onSuccess()
        }
    }

    const today = new Date().toISOString().slice(0, 10)

    return (
        <div>
            <b>{invoice.companyName}</b>
            <p className="has-text-grey is-size-7">
                Договор: {invoice.expectedAmount} &nbsp;·&nbsp;
                Оплачено: {invoice.paid} &nbsp;·&nbsp;
                Остаток: {invoice.debt}
            </p>
            <br />
            <ServerError error={create.error} />

            <Formik
                onSubmit={onSubmit}
                initialValues={{
                    amount: invoice.debt > 0 ? invoice.debt : '',
                    paidAt: today,
                    method: 'cash',
                    comment: '',
                }}>
                <Form>
                    <Input name="amount" type="number" label="Сумма" validate={required} />
                    <Input name="paidAt" type="date" label="Дата оплаты" validate={required} />
                    <Select name="method" label="Способ оплаты" options={METHODS} />
                    <Input name="comment" label="Комментарий" optional />

                    <Button
                        loading={create.loading}
                        text="Сохранить"
                        type="submit"
                        icon="ion-md-checkmark"
                        className="is-success" />
                    &nbsp;
                    <Button onClick={onCancel} text="Отмена" icon="ion-md-close" className="is-danger" />
                </Form>
            </Formik>
        </div>
    )
}
